import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";
import i18n from "../i18n";

/* eslint-disable no-console */

const ContractStore = {
  namespaced: true,
  debug: true,
  state: {
    userInfo: {},
    contractInfo: {}
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setContractInfo(state, data) {
      state.contractInfo = data;
    }
  },
  getters: {
    getUserInfo(state) {
      let result = state.userInfo;
      if (result !== "") {
        if (result.sex != null) {
          result.sex = store.getters[
            "constantStore/constant/constantStore/getSexData"
          ](result.sex);
        }
        if (result.prefectures != null) {
          result.prefectures = store.getters[
            "constantStore/constant/constantStore/getPrefecturesData"
          ](result.prefectures);
        }
        if (result.birthday != null) {
          result.birthday = moment(result.birthday).format("YYYY-MM-DD");
        }
      } else {
        result = {
          lastname: "",
          firstname: "",
          lastnamekana: "",
          firstnamekana: "",
          sex: "",
          phone: "",
          birthday: "",
          zipCode: "",
          prefectures: "",
          city: "",
          address: "",
          building: ""
        };
      }
      return result;
    },
    getContractInfo(state) {
      if (state.contractInfo === "") {
        return (result = {
          contractdate: "",
          joindate: "",
          status: store.getters[
            "constantStore/constant/constantStore/getMemberStatusData"
          ]("non").label,
          reservationavailablecount: 0,
          lastmonthstatus: store.getters[
            "constantStore/constant/constantStore/getMemberStatusData"
          ]("non").label
        });
      }
      let result = {
        contractdate: "",
        joindate: "",
        reservationavailablecount: state.contractInfo.reservationavailablecount,
        lastMonthReservationavailablecount:
          state.contractInfo.lastmonthreservationavailablecount,
        isMemberFlag: false
      };
      if (state.contractInfo.lastmonthreservationavailablecount === null) {
        result.lastMonthReservationavailablecount = 0;
      }
      if (state.contractInfo.status === "unlimited") {
        result.reservationavailablecount = "∞";
      }
      if (
        state.contractInfo.startdate !== null &&
        state.contractInfo.startdate !== ""
      ) {
        result.contractdate =
          moment(state.contractInfo.startdate).format("YYYY/MM/DD") +
          "~" +
          moment(state.contractInfo.enddate).format("YYYY/MM/DD");
        result.startdate = moment(state.contractInfo.startdate);
        result.enddate = moment(state.contractInfo.enddate);
      }
      if (state.contractInfo.status !== null && state.contractInfo.status) {
        result.status = store.getters[
          "constantStore/constant/constantStore/getMemberStatusData"
        ](state.contractInfo.status).label;
      }
      if (
        state.contractInfo.automaticupdatingdate != null &&
        state.contractInfo.automaticupdatingdate != ""
      ) {
        if (
          state.contractInfo.automaticupdatingdate <=
          moment().format("YYYY-MM-DD")
        ) {
          if (
            state.contractInfo.status !== null &&
            state.contractInfo.status !==
              store.getters[
                "constantStore/constant/constantStore/getMemberStatusData"
              ]("non").value
          ) {
            result.isMemberFlag = true;
          }
        } else {
          if (
            state.contractInfo.lastmonthstatus !== null &&
            state.contractInfo.lastmonthstatus !==
              store.getters[
                "constantStore/constant/constantStore/getMemberStatusData"
              ]("non").value
          ) {
            result.isMemberFlag = true;
          }
        }
      } else {
        if (
          state.contractInfo.status !== null &&
          state.contractInfo.status !==
            store.getters[
              "constantStore/constant/constantStore/getMemberStatusData"
            ]("non").value
        ) {
          result.isMemberFlag = true;
        }
      }
      if (state.contractInfo.lastmonthstatus === "unlimited") {
        result.lastMonthReservationavailablecount = "∞";
      }
      if (
        state.contractInfo.lastmonthstatus !== null &&
        state.contractInfo.lastmonthstatus
      ) {
        result.lastMonthStatus = store.getters[
          "constantStore/constant/constantStore/getMemberStatusData"
        ](state.contractInfo.lastmonthstatus).label;
      }
      result.reservationLabel =
        "（" +
        i18n.t("page.userInfo.periodBeforeMessage") +
        moment(state.contractInfo.enddate).format(
          i18n.t("page.userInfo.period")
        ) +
        i18n.t("page.userInfo.periodAfterMessage") +
        "）";
      result.lastMonthReservationLabel =
        "（" +
        i18n.t("page.userInfo.periodBeforeMessage") +
        moment(state.contractInfo.enddate)
          .add(-1, "month")
          .endOf("month")
          .format(i18n.t("page.userInfo.period")) +
        i18n.t("page.userInfo.periodAfterMessage") +
        "）";
      result.statusLabel =
        "（" +
        i18n.t("page.userInfo.periodBeforeMessage") +
        moment(state.contractInfo.enddate).format(
          i18n.t("page.userInfo.period")
        ) +
        i18n.t("page.userInfo.periodAfterMessage") +
        "）";
      result.lastMonthStatusLabel =
        "（" +
        i18n.t("page.userInfo.periodBeforeMessage") +
        moment(state.contractInfo.enddate)
          .add(-1, "month")
          .endOf("month")
          .format(i18n.t("page.userInfo.period")) +
        i18n.t("page.userInfo.periodAfterMessage") +
        "）";
      result.automaticUpdatingDate = state.contractInfo.automaticupdatingdate;
      return result;
    }
  },
  actions: {
    async callApiUserInfo({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let userInfo = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/userInfo",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          if (userInfo.data.length > 0) {
            commit("setUserInfo", userInfo.data[0]);
          } else {
            commit("setUserInfo", "");
          }
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiContractInfo({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let contractInfo = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/contractInfo",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          if (contractInfo.data.length > 0) {
            commit("setContractInfo", contractInfo.data[0]);
          } else {
            commit("setContractInfo", "");
          }
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default ContractStore;
